import React, {useState} from 'react';
import {AuthenticatedTemplate, UnauthenticatedTemplate, useAccount, useMsal} from "@azure/msal-react";
import {loginRequest} from "../../authConfig";
import {useDispatch, useSelector} from "react-redux";
import * as actions from "../../actions/JobActions";
import {loadJobs} from "../helper functions/LoadJobs";


export function JobCompleteList() {
    const {instance} = useMsal();
    const account = useAccount();

    const loginRedirect = () => {
        instance.loginRedirect(loginRequest).catch((error) => console.log(error));
    };

    const dispatch = useDispatch()
    let sort = useSelector(state => state.jobSortComplete);
    let search = useSelector(state => state.jobSearchComplete);
    const [loading, setLoading] = useState(true)

    return (
        <div>
            <UnauthenticatedTemplate>
                <h5 className="no-access-message"> Sorry, you don't have access to this page! </h5>
            </UnauthenticatedTemplate>

            <AuthenticatedTemplate>
                <div className="page-title-sh26">
                    <h1>Completed job list</h1>
                    <p> A list of all jobs that are completed</p>
                </div>
                <hr/>

                <div className="dropdown">
                    <div className="dropdown-btn btn-secondary"> Sort by:</div>
                    <div className="dropdown-content">
                        <a onClick={sort => {
                            dispatch(actions.SortNew("COMPLETE"))
                        }}>Newest First </a>
                        <a onClick={sort => dispatch(actions.SortOld("COMPLETE"))}>Oldest First</a>
                        <a onClick={sort => dispatch(actions.SortAtoZ("COMPLETE"))}> A-Z </a>
                    </div>
                </div>

                <div className="search">
                    <input id="search-input" type="text" className="search-box"
                           placeholder="Which job are you looking for?"/>
                    <button className="search-btn btn-secondary btn"
                            onClick={search => dispatch(actions.completeSearch(document.getElementById("search-input").value, "COMPLETE"))}> 🔍
                    </button>
                </div>

                <div className="page-break"></div>
                <br/>

                <div>
                    {loadJobs(sort, search)}
                </div>
            </AuthenticatedTemplate>
        </div>
    );
}
